define('lib/util/tda.config',['jquery'], function ($) {

  /*
  Meta tags are added via LSDS:
  application/LiveSiteDisplayServices-7.3.2/WEB-INF/classes/com/interwoven/xsl/runtime/fixed-layout.page.xsl
  They are populated via TeamSite's TDA_config.
  Not ALL available TDA_config are being output as Meta Tags,
  just those that are currently in use via javascript
  (see shared-template.xsl, #defaultzipcode element)
  */

  var config = {};
  var prefix = 'bat:';

  $('head meta').each(function (idx) {
    var $tag = $(this);
    var name = $tag.attr('name');

    if (!name || name.indexOf(prefix) !== 0) return;

    var value = $tag.attr('content');
    if (!value || value.length === 0) {
      value = $tag.text();
    }

    var tokens = name.substring(prefix.length).split(':');
    if (tokens.length > 1) {
      var ctx = config;
      tokens.slice(0, tokens.length - 1).forEach(function (t) {
        ctx[t] || (ctx[t] = {});
        ctx = ctx[t];
      });

      ctx[tokens[tokens.length - 1]] = value;
    } else {
      config[tokens[0]] = value;
    }
  });

  return config;
});

